import { inject, Injectable } from '@angular/core';
import { AutoIncrementService } from '@control-tower/platform-core';
import { map, Observable } from 'rxjs';

export enum AutoIncrementerType {
    LoadNumber = 'Load Number',
    ZoneBarcode = 'Zone Barcode',
    SlotBarcode = 'Slot Barcode',
}

@Injectable({
    providedIn: 'root',
})
export class AutoIncrementerFacade {
    private autoIncrementService = inject(AutoIncrementService);

    getIncrement(
        type: AutoIncrementerType | string
    ): Observable<string | undefined | null> {
        return this.autoIncrementService
            .autoIncrementerIncrement({
                type,
            })
            .pipe(map(x => x.formatted));
    }
}
